import { render, staticRenderFns } from "./listar-programas.vue?vue&type=template&id=2d280282"
import script from "./listar-programas.vue?vue&type=script&lang=js"
export * from "./listar-programas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports